export default __webpack_public_path__ + "static/media/holidayssettings.53ba9317.svg";